/**
 * PLT-6267 — the Suppliers page's own path, in one place.
 *
 * Shared between the nav row's `to` and the dashboard route's `path`, following the Climate pages
 * (`climate/constants.ts`) rather than the other four Input-data pages, which each spell their
 * path twice. `getAriaCurrent` marks the current row with a naive
 * `currentPath.includes(path)` (`styled-nav-components.tsx`), so two literals that drift by a
 * character leave the rail with no current row — and a path that is a prefix of another marks
 * both.
 */
export const SUPPLIERS_BASE_PATH = 'suppliers';

/**
 * The wizard's step segments under the Suppliers page. The same two the investor host uses, on
 * purpose: `NewCompanyWizardView` tests for them with `pathname.includes(...)` to decide whether
 * it is still inside its own flow, so a host that spelled them differently would need that
 * predicate parameterised for nothing.
 */
export const SUPPLIER_WIZARD_SEGMENT = 'create-company';
export const SUPPLIER_REVIEW_PRODUCTS_SEGMENT = 'review-products';

/**
 * PLT-6276 — the Edit company dialog under the Suppliers page: `<suppliers>/edit-company/:companyId`,
 * with the tab a count opened after it. Spelled like the investor host's segment.
 */
export const SUPPLIER_EDIT_SEGMENT = 'edit-company';
